<template>
	<div class="upload-video-wrap">
		<div class="upload-video-left" v-bind="$attrs">
			<div v-if="modelValue" class="upload-video-con" @click.prevent="selectFile" >
				<video :src="modelValue"  controls="controls"></video>
			</div>
			<template v-else>
				<div class="upload-video-con" @click="selectFile" v-if="process === ''">
					<i class="el-icon-plus"></i>
				</div>
				<div class="upload-video-con" v-else>
					<div class="process">
						<div class="process_con">
							<el-progress
								:percentage="process"
								style="width: 80%"
								:show-text="false"
								:color="type == 'error' ? 'red' : '#4e70f2'"
							></el-progress>
							<i
							class="iconfont del_process"
							v-if="type == 'error'"
							@click="delUpload"
							>&#xe615;</i
							>
						</div>
						<p>{{ process }}%</p>
						
					</div>
				</div>
			</template>
		</div>
		<div class="upload-video-right">
			<span>1、比例支持1:1、3:4及9:16比例视频</span>
			<span>2、建议内存100M以内</span>
			<span>3、视频格式仅支持mp4</span>
		</div>
		<SucaiDialog v-model="visible" ref="materialRef" v-bind="materialParams" v-on="$listeners" @beforeUpload="beforeUpload" @change="uploadFun" @uploadSucess="uploadSucess" @sureClick="uploadSucess"></SucaiDialog>
	</div>
</template>
<script>
	import SucaiDialog from '@/components/sucaikuDialog/sucaikuDialog.vue'
	export default {
		name: 'UploadVideo',
		model: {
			prop: 'modelvalue',
			event: 'input'
		},
		props: {
			materialObj: {
				type: Object,
				default: () => {}
			},
			uploadObj: {
				type: Object,
				default: () => {}
			},
			modelvalue: {
				type: String,
				default: ''
			},
			isDestory: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				fileSizeList: [
					{
						value: 1,
						label: 'b'
					},
					{
						value: 1024,
						label: 'kb'
					},
					{
						value: 1024 * 1024,
						label: 'mb'
					},
					{
						value: 1024 * 1024 * 1024,
						label: 'gb'
					},
				],
				visible: false,
				process: '',
				type: ''
			}
		},
		components: {
			SucaiDialog,
			uploadCon: {
				data() {
					return {
						
					}
				}
			}
		},
		computed: {
			modelValue: {
				get() {
					return this.modelvalue
				},
				set(news) {
					console.log(news, '=====modelValuemodelValue')
					this.$emit('input', news)
					this.$emit('changeUrl', news)
				}
			},
			uploadParams() {
				const defaultParams = {}
				return {...defaultParams, ...this.uploadObj}
			},
			materialParams() {
				console.log(this)
				const accept = ['.mp4']
				const uploadSize = '100mb'
				const defaultParams = {
					uploadType: 'video',
					uploadTitle: '点击上传本地视频',
					btnTitle: '播放',
					accept,
					addNumber: 0,
					listW: '240px',
					listH: '185px',
					rowNum: 4,
					limit: 8,
					dialogWidth: '1060px',
					isUploadFlag: false,
					uploadSize,
					disabledFun: (item) => {
						return !accept.includes(item.suffix) || this.handleFileSize(item.material_size) > this.handleFileSize(uploadSize)
					}
				}
				return {...defaultParams, ...this.materialObj}
			},
		},
		methods: {
			handleFileSize(size) {
				let uploadSize = size.toLowerCase()
				let unit = uploadSize.replace(/[\d.\s]/g,'')
				let uploadNum = parseInt(uploadSize)
				let obj = this.fileSizeList.find(item => item.label == unit)
				return uploadNum * obj.value
			},
			selectFile() {
				this.visible = true
			},
			beforeUpload(list) {
				this.modelValue = ''
				this.process = 0
			},
			uploadFun(list) {
				this.process = list[0].process
				if(this.isDestory) {
					this.process = ''
					this.type = ''
				}
				this.type = list[0].type
			},
			uploadSucess(list) {
				this.modelValue = list[0].url
			},
			delUpload() {
				this.process = ''
				this.type = ''
				this.modelValue = ''
			}
		},
		watch: {
			isDestory(news) {
				if(!news) {
					return
				}
				if(this.process !== '') {
					this.$refs.materialRef.cancelUpload()
				}
			}
		},
		beforeDestroy() {
			this.$refs.materialRef.cancelUpload()
			this.process = ''
			this.type = ''
		}
	}
</script>
<style lang="less" scoped>
	.upload-video-wrap {
        display: flex;
		.upload-video-left {
			background-color: #f3f4f9;
			border: 1px solid #e3e5ee;
			border-radius: 6px;
			overflow: hidden;
			width: 320px; 
			height: 240px;
			margin-right: 12px;
		}
		.upload-video-right {
			position: relative;
			display: flex;
			flex-direction: column;
			font-size: 14px;
			color: #909399;
			line-height: 24px;
			padding: 10px 0;
		}
		.upload-video-con {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			video {
				width: 100%;
				height: 100%;
			}
		}
		.el-icon-plus {
			font-size: 28px;
    		color: #c7cada;
		}
		.process {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
		}
		.process_con {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
			.iconfont {
				margin-left: 6px;
				color: red;
				cursor: pointer;
			}
		}
	}
</style>
